import { useFormikContext } from 'formik'

import { useTimeZone } from '../../../../hooks'
import { FormActions } from '../../../Form'
import { CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS } from '../CalendarRelieveDayModal.constants'
import { getIsCalendarRelieveDaySubmitDisabled } from '../CalendarRelieveDayModal.utils'

function CalendarRelieveDayModalActions({ day, submitProps, ...actionsProps }) {
  const timezone = useTimeZone()

  const { values } = useFormikContext()

  return (
    <FormActions
      {...actionsProps}
      submitProps={{
        ...submitProps,
        disabled: getIsCalendarRelieveDaySubmitDisabled({
          day,
          timezone,
          values,
        }),
        translationParams: {
          count: values[CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS].length,
        },
      }}
    />
  )
}

export default CalendarRelieveDayModalActions
